import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  warning: {
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    backgroundColor: theme.colorPalette.green_30,
    color: theme.colors.white
  },
  icon: {
    width: 16,
    height: 16
  },
  header: {
    padding: theme.spacing(0),
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colors.white
  },
  text: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colors.white,
    padding: theme.spacing(1, 0)
  },
  extraBottomPadding: {
    paddingBottom: theme.spacing(2)
  }
});

export default makeStyles(styles);
